import { useTypeSafeMutation } from '@oresundsbron/api';
import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { isValidPageLanguage } from '~/types/languages';

interface SubscribeToTrafficInformationProps {
  onSuccess: () => void;
  onError: () => void;
}

export const useSubscribeToTrafficInformation = ({
  onSuccess,
  onError,
}: SubscribeToTrafficInformationProps) => {
  const { locale } = useRouter();

  const { mutateAsync } = useTypeSafeMutation(
    [],
    ({ TrafficInformationSubscription }) =>
      TrafficInformationSubscription.subscribe,
    {
      onSuccess,
      onError,
    }
  );

  const subscribe = useCallback(
    async (email: string, type: 'subscribe' | 'unsubscribe') => {
      if (locale && isValidPageLanguage(locale)) {
        await mutateAsync({
          email: email,
          language: locale,
          type: type,
        });
      }
    },
    [mutateAsync, locale]
  );
  return subscribe;
};
